<shared-ui-modal-base-modal [cancelButtonTitle]="'Cancel'" [confirmButtonTitle]="'Confirm'" [canConfirm]="true" [title]="title" (confirmOutput)="confirmOutput.emit()">
  <div>{{ body }}</div>
</shared-ui-modal-base-modal>
